import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import firebase from 'firebase/app'
import Router from 'vue-router'
import VModal from 'vue-js-modal';
import 'firebase/firestore'
import vueSmoothScroll from 'vue2-smooth-scroll'
import _ from 'lodash'

import './filters'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

window.Vue = Vue;
window.$ = require('jquery')
window._ = _

Vue.use(Router)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)

import router from './router'

Vue.use(VModal, { dialog: true })
Vue.config.productionTip = false
Vue.use(vueSmoothScroll)
window.axios = axios.create({
  baseURL: '/api/v1/',
  timeout: 500000
})

window.axios.interceptors.request.use(function (config) {
  config.headers['Authorization'] = 'Bearer ' + (localStorage.getItem('auth_token') || '')
  return config
})

window.axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  console.log(error)
  return Promise.reject(error)
})

import apiClient from './backend'
window.apiClient = apiClient

var firebaseConfig = {
  apiKey: "AIzaSyAQHS8NECtomYOqlIApl3xVmxIKAcVUCws",
  authDomain: "nappl-4261d.firebaseapp.com",
  databaseURL: "https://nappl-4261d.firebaseio.com",
  projectId: "nappl-4261d",
  storageBucket: "nappl-4261d.appspot.com",
  messagingSenderId: "396652629504",
  appId: "1:396652629504:web:efc77e562b2e99e02d12e5",
  measurementId: "G-W86XGNR6WN"
};

firebase.initializeApp(firebaseConfig);
window.db = firebase.firestore();